const removeWaterMark = {
  ExportVideoWithoutWaterMark: 'Export Video Without HitPaw Watermark',
  ExportWithoutLimits: 'Export Video Without Limits',
  MaximumUpload500MB: 'Maximum Upload File Size: 500MB',
  watermarkRemoveTitle: 'HitPaw Online Video Watermark Remover',
  DiscountPrice: '$0.99',
  WeekTotalPrice: '$4.49',

  MonthWeekPrice: '$1.75',
  MonthTotalPrice: '$6.99',

  YearWeekPrice: '$0.87',
  YearTotalPrice: '$41.88',
  Day: 'Day',
  Monthly: 'Monthly',
  Weekly: 'Weekly',
  Yearly: 'Yearly',
};

export default removeWaterMark;
